import React from 'react';
import clsx from 'clsx';
import {
	clearIndicatorStyles,
	controlStyles,
	dropdownIndicatorStyles,
	groupHeadingStyles,
	indicatorsContainerStyles,
	indicatorSeparatorStyles,
	menuStyles,
	multiValueLabelStyles,
	multiValueRemoveStyles,
	multiValueStyles,
	noOptionsMessageStyles,
	optionStyles,
	placeholderStyles,
	selectInputStyles,
	singleValueStyles,
	valueContainerStyles,
} from '@app/component/form/input/autocomplete/AutocompleteStyles';
import Select from 'react-select';
import Country from '@app/model/hotel/Country';
import isEmpty from 'lodash/isEmpty';
import { useQuery } from '@tanstack/react-query';
import RefDataService from '@app/model/refdata/service/RefDataService';
import { CountriesQueryKeys } from '@app/model/refdata/service/RefDataQueryKeys';
import { FieldErrors } from '@app/site/_form/field/FieldErrors';
import { useFieldContext } from '@app/site/_form';


type CountryFieldProps = {
	label?: string,
	placeholder?: string,
}
export const CountryField: React.FunctionComponent<CountryFieldProps> = ({ label, placeholder }) => {

	const field = useFieldContext<number>();

	const { data } = useQuery({
		queryFn: RefDataService.findCountries,
		queryKey: CountriesQueryKeys.all,
	});

	if (isEmpty(data)) return <></>;

	const formatOptionLabel = (country: Country) => (
		<div style={{ display: 'flex' }}>
			<div>{country.name}</div>
		</div>
	);

	const findCountry = (id: number) => {
		if (!isEmpty(data)) {
			return data!.find(o => o.id === id);
		}
		return undefined;
	};

	const hasError = field.state.meta.isTouched && !field.state.meta.isValid;
	

	return <div>
		{!!label && <div className="label">Country</div>}
		<div className="mt-0.5">
			<Select placeholder={!!placeholder ? placeholder : ''}
							unstyled
							getOptionValue={(o: Country) => '' + o.id}
							getOptionLabel={(o: Country) => o.name}
							formatOptionLabel={formatOptionLabel}
							options={data}
							value={findCountry(field.state.value)}
							menuPortalTarget={document.body}
							onChange={(v: Country) => field.handleChange(v.id)}
							styles={{
								input: (base) => ({
									...base,
									'input:focus': {
										boxShadow: 'none',
									},
								}),
							}}
							classNames={{
								control: ({ isFocused }) =>
									clsx(
										isFocused ? controlStyles(hasError).focus : controlStyles(hasError).nonFocus,
										controlStyles(hasError).base,
									),
								placeholder: () => placeholderStyles(hasError),
								input: () => selectInputStyles,
								valueContainer: () => valueContainerStyles,
								singleValue: () => singleValueStyles,
								multiValue: () => multiValueStyles,
								multiValueLabel: () => multiValueLabelStyles,
								multiValueRemove: () => multiValueRemoveStyles,
								indicatorsContainer: () => indicatorsContainerStyles,
								clearIndicator: () => clearIndicatorStyles,
								indicatorSeparator: () => indicatorSeparatorStyles,
								dropdownIndicator: () => dropdownIndicatorStyles,
								menu: () => menuStyles,
								groupHeading: () => groupHeadingStyles,
								option: ({ isFocused, isSelected }) =>
									clsx(
										isFocused && optionStyles.focus,
										isSelected && optionStyles.selected,
										optionStyles.base,
									),
								noOptionsMessage: () => noOptionsMessageStyles,
							}}
			/>

		</div>
		<FieldErrors meta={field.state.meta} />
	</div>;
};
